import { getFromBreakpoint } from '@vakantiesnl/components/src/styles/breakpoints';
import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	flightContainer: {
		display: 'flex',
		width: '100%',
		gap: theme.spacing.small,

		[getFromBreakpoint('md')]: {
			zIndex: theme.zIndex.default,
			position: 'relative',
		},
	},
	recommendedFlightTitle: {
		margin: `${theme.spacing.small} 0 ${theme.spacing.xsmall}`,

		[getFromBreakpoint('md')]: {
			margin: `0 0 ${theme.spacing.small} 0`,
		},
	},
	flights: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		gap: theme.spacing.small,
	},
	modalFlights: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		height: '100%',
		overflowY: 'scroll',
		gap: theme.spacing.small,
		paddingBottom: theme.spacing.small,
	},
	flightsHeader: {
		margin: `${theme.spacing.small} 0`,
	},
	flightsModal: {
		[getFromBreakpoint('md')]: {
			left: '30%',
		},
	},
	flightsModalContent: {
		padding: `0 ${theme.spacing.small}`,
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.small,
		height: `calc(100% - ${theme.spacing.tiny})`,
		paddingTop: theme.spacing.tiny,

		[getFromBreakpoint('md')]: {
			paddingTop: 0,
			height: '100%',
		},
	},
	alternativeFlightsTextContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.xxsmall,

		[getFromBreakpoint('md')]: {
			gap: theme.spacing.xsmall,
		},
	},
	alternativeFlightsButtonContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: theme.spacing.xxsmall,

		[getFromBreakpoint('md')]: {
			gap: theme.spacing.small,
			alignItems: 'flex-start',
		},
	},
}));
